<template>
  <HeaderContent title="Staff" />
  <ActionContent
    ctaText="Add Staff"
    :filterDate="false"
    :filterModal="false"
    v-model:search="search"
    @action="showModal"
    @search-query="searchData"
  />
  <StaffStatistics title="Staff Statistics" :data="statistics" />
  <StaffForm
    :modal="modal"
    :staffData="staff"
    @update:modal="updateModal"
    @addOrUpdate="getAll"
  />
  <StaffConfirm
    title="Confirmation"
    :uuid="staffUuid"
    v-model="modalConfirm"
    @confirmed="deleteData(staffUuid)"
  >
    <template #text>Are you sure you want to delete this staff?</template>
  </StaffConfirm>
  <StaffDataTable
    :data="staffs"
    :header="headers"
    :currentPage="currentPage"
    :custom-actions="customActions"
  />
  <ToastResponse
    v-model="modalResponse.toast"
    :text="modalResponse.text"
    :success="modalResponse.success"
  />
</template>

<script>
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";

import StaffForm from "./StaffForm.vue";
import StaffDataTable from "@/components/DataTable.vue";
import StaffStatistics from "@/components/StatisticData.vue";
import StaffConfirm from "@/components/ModalDialog.vue";
import iconUser from "../../../public/icons/users-alt.svg";
import ToastResponse from "@/components/ToastResponse.vue";

import { ref, inject, onMounted } from "vue";

export default {
  components: {
    HeaderContent,
    ActionContent,
    StaffForm,
    StaffDataTable,
    StaffStatistics,
    StaffConfirm,
    ToastResponse,
  },
  setup() {
    const repositories = inject("repositories");
    const staffRepository = repositories?.employee;

    const modal = ref(false);
    const modalConfirm = ref(false);
    const staffUuid = ref(null);
    const staff = ref({});
    const staffs = ref([]);
    const currentPage = ref(1);
    const search = ref("");

    const headers = ref([
      { key: "no", label: "No", class: "text-left" },
      { key: "fullname", label: "Name", sortable: true, class: "text-left" },
      {
        key: "position_name",
        label: "Position",
        sortable: true,
        class: "text-left",
      },
      { key: "phone", label: "Phone", sortable: true, class: "text-left" },
      { key: "email", label: "Email", sortable: true, class: "text-left" },
      {
        key: "address",
        label: "Address",
        sortable: true,
        class: "text-left",
      },
      {
        key: "status",
        label: "Status",
        sortable: true,
        class: "text-center",
      },
      { key: "action", label: "Actions" },
    ]);

    const statistics = ref([]);

    const customActions = ref([
      {
        label: "Edit",
        variant: "success",
        icon: "fas fa-edit",
        action: (item) => {
          getById(item.uuid);
        },
      },
      {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        action: (item) => {
          showConfirmModal(item.uuid);
        },
      },
    ]);

    const getAll = async (searchQuery = "") => {
      const params = {};

      if (searchQuery) params.search = searchQuery;
      try {
        const res = await staffRepository.getAll(params);
        staffs.value = res.data.data.map((item, index) => ({
          ...item,
          no: index,
          // status: item.status === "non-active" ? "Non-Active" : item.status === "active" ? "Active" : "Inactive",
          //   position_name: item.position_name ?? "-",
        }));

        statistics.value = [
          {
            label: "Total",
            key: "Staff",
            value: staffs.value.length,
            color: "primary",
            icon: iconUser,
          },
        ];
      } catch (err) {
        console.error("Failed to fetch staff data:", err);
      }
    };

    const getById = async (uuid) => {
      try {
        const res = await staffRepository.getById(uuid);
        staff.value = res.data.data;
        modal.value = true;
        console.log("Data Staff:", res.data.data);
      } catch (err) {
        console.error("Failed to get staff by ID:", err);
      }
    };

    const updateModal = (newVal) => {
      modal.value = newVal;
      staff.value = {};
    };

    const showModal = () => {
      modal.value = true;
      staff.value = {};
    };

    const showConfirmModal = (uuid) => {
      modalConfirm.value = true;
      staffUuid.value = uuid;
    };

    const modalResponse = ref({
      toast: false,
      text: "",
      success: false,
    });

    const deleteData = async (uuid) => {
      try {
        await staffRepository.delete(uuid);
        modalConfirm.value = false;
        getAll();
      } catch (err) {
        console.error("Failed to delete staff:", err);
        Object.assign(modalResponse.value, {
          success: false,
          text: err.response.data.message,
          toast: true,
        });
      }
    };

    function handleSearch(query) {
      search.value = query;
      getAll(query);
    }

    const searchData = async (keyword) => {
      // try {
      //   const res = await staffRepository.search(keyword);
      //   staffs.value = res.data.data;
      // } catch (err) {
      //   console.error("Search error:", err);
      // }
      getAll(keyword);
    };

    onMounted(() => {
      getAll();
    });

    return {
      modal,
      modalConfirm,
      staffUuid,
      staff,
      staffs,
      headers,
      statistics,
      currentPage,
      customActions,
      updateModal,
      showModal,
      showConfirmModal,
      deleteData,
      getAll,
      getById,
      search,
      searchData,
      handleSearch,
      modalResponse,
    };
  },
};
</script>
